import { AsyncRequest } from 'angieslist-app-platform';
import appDownloadActionKeys from './appDownloadActionKeys';

export default AsyncRequest.createReducer(appDownloadActionKeys.SEND_APP_LINK, {
  [appDownloadActionKeys.SEND_APP_LINK_SUCCESS]: state =>
    AsyncRequest.setSuccess(state, { success: true }),
});



// WEBPACK FOOTER //
// ./src/app/common/download/appDownloadReducer.js